import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type YourStatsProps = {
  hide: boolean;
  userStats: {
    platformMinutes: number;
    mindfulMinutes: number;
    activeMinutes: number;
  };
  handleModalOpen: (value: boolean) => void;
};
export function YourStats({ hide, userStats, handleModalOpen }: YourStatsProps) {
  const { t } = useTranslation();

  const openModal = () => {
    handleModalOpen(true);
  };

  return (
    <div id="your-stats" className={`rm-box ${hide ? 'mt' : ''} fs-exclude`}>
      <div className="profile-name left">
        {t('S047')}
        <button type="button" onClick={openModal} className="transparent-button icon-button">
          <span className="visuallyHidden">{t('open.modal.your.stats')}</span>
          <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
        </button>
      </div>
      <div className="streaks-cont">
        <div className="streak-clmn-full">
          <StreakLine name={t('S048')} number={userStats.platformMinutes} />
          <StreakLine name={t('S049')} number={userStats.mindfulMinutes} />
          <StreakLine name={t('S050')} number={userStats.activeMinutes} />
        </div>
      </div>
    </div>
  );
}

function StreakLine({ name, number }) {
  return (
    <div className="streak-line" aria-label={`${name}  ${number}`} role="group">
      <div className="streak-name stats" aria-hidden="true">
        {name}
      </div>
      {formatNumber(number)}
    </div>
  );
}

const formatNumber = (number) => {
  // Format the number with commas
  const safeNumber = number < 0 || number === null ? 0 : number;

  const formattedNumber = safeNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Split the formatted number into individual characters (digits and commas)
  const characters = formattedNumber.split('');

  return (
    <div className="profile-name left nm" aria-hidden="true">
      {characters.map((char, index) =>
        char === ',' ? (
          // Odometer digits are positional, the index is the character position in the number.
          // eslint-disable-next-line react/no-array-index-key
          <span key={index}>,</span>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <div className="scrolling-container" key={index}>
            <div className="scrolling-number">
              <span key={char} className="current">
                {char}
              </span>
            </div>
          </div>
        )
      )}
    </div>
  );
};
